import * as React from 'react';

import styled from '@emotion/styled';

import { COLORS, Text, mq } from '@clutter/clean';

import { ButtonCTA } from '@shared/button_cta';
import { ServiceSelection } from '@shared/service_selector/constants';
import { ValuePropCard } from '@shared/value_prop_card';

import truckTracking from '@images/illustrations/location_truck_tracking.svg';
import photoCatalog from '@images/illustrations/online_photo_catalog_small.svg';

const VALUE_PROPS = [
  {
    title: 'Digital walkthroughs',
    description:
      'Every move is different! Complete a digital walkthrough of your home so our team can come prepared for your move.',
    illustration: photoCatalog,
  },
  {
    title: 'Track your truck online',
    description:
      'The day of your move you’ll be able to track our team and know exactly when they’ll arrive at your home.',
    illustration: truckTracking,
  },
] as const;

const Container = styled.div`
  letter-spacing: initial;
  text-align: center;
  color: ${COLORS.tealDark};
  overflow-x: hidden;

  ${mq({
    padding: ['48px 0 0', '88px 0'],
  })}
`;

const FluidContainer = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  ${mq({
    padding: ['0 24px', 0, '0 24px'],
  })}
`;

const Content = styled.div`
  display: flex;
  justify-content: space-evenly;

  ${mq({
    margin: ['20px auto', '80px auto 48px'],
    flexDirection: ['column', 'row'],
  })};

  & > div {
    ${mq({ padding: ['34px 24px', '8px'] })};
  }
`;

export const MovingPreview: React.FC<{
  title?: string;
}> = ({ title = 'A technology-first approach to moving' }) => (
  <Container>
    <FluidContainer>
      <Text.Title size="large">{title}</Text.Title>
      <Content>
        {VALUE_PROPS.map(({ title, description, illustration }, key) => (
          <ValuePropCard
            key={key}
            title={title}
            description={description}
            illustration={illustration}
          />
        ))}
      </Content>
      <ButtonCTA
        container="moving_preview"
        entryPoint="service_page_button"
        label="Get a Quote"
        service={ServiceSelection.Moving}
      />
    </FluidContainer>
  </Container>
);
